export default __webpack_public_path__ + "static/media/Fund members@2x-min.57889c63.png";